<div class="mx-auto px-2 sm:px-6 lg:px-8 mt-6 mb-12 animate-fade-in">
    <div class="bg-white rounded-3xl border border-gray-200 overflow-hidden">
        <div class="bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-10 text-white relative">
            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                <div class="max-w-2xl">
                    <h2 class="text-3xl font-extrabold tracking-tight">Advisor Onboarding</h2>
                    <p class="text-indigo-100 mt-2 text-lg">Create a professional profile and link them to your property listings.</p>
                </div>

                <div class="flex flex-col items-center gap-3">
                    <div class="relative group cursor-pointer" (click)="fileInput.click()">
                        <div class="w-32 h-32 rounded-full border-4 border-white/30 bg-white/10 flex items-center justify-center backdrop-blur-md overflow-hidden transition-all group-hover:border-white/60">
                            @if(imagePreview) {
                            <img [src]="imagePreview" class="w-full h-full object-cover">
                            } @else {
                            <svg class="w-12 h-12 text-white/50 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            }
                            <div class="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                <span class="text-xs font-bold uppercase tracking-wider">Upload</span>
                            </div>
                        </div>
                        <input #fileInput type="file" class="hidden" accept="image/*" (change)="onFileSelected($event)">
                    </div>
                    <span class="text-xs font-bold text-indigo-100 uppercase tracking-widest">Profile Photo <span class="text-yellow-500">*</span></span>
                </div>
            </div>
        </div>

        <form [formGroup]="advisorForm" (ngSubmit)="onSubmit()" class="p-8 lg:p-12 space-y-10">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div>
                    <h3 class="text-xl font-bold text-gray-900">Professional Details</h3>
                    <p class="text-sm text-gray-500 mt-1">Basic identification and expertise areas.</p>
                </div>
                <div class="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
    
                    <div class="space-y-1">
                        <label class="text-sm font-bold text-gray-700 ml-1">Full Name <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="name" placeholder="John Smith" 
                            [class.border-red-500]="advisorForm.get('name')?.invalid && advisorForm.get('name')?.touched"
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('name')?.invalid && advisorForm.get('name')?.touched" class="text-xs text-red-500 ml-1">Name is required (min 3 chars)</p>
                    </div>
                
                    <div class="space-y-1">
                        <label class="text-sm font-bold text-gray-700 ml-1">Specialization <span class="text-red-500">*</span></label>
                        <select formControlName="specialization" 
                            [class.border-red-500]="advisorForm.get('specialization')?.invalid && advisorForm.get('specialization')?.touched"
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                            <option value="" disabled selected>Select</option>
                            <option value="Specialist Advisor">Specialist Advisor</option>
                        </select>
                        <p *ngIf="advisorForm.get('specialization')?.invalid && advisorForm.get('specialization')?.touched" class="text-xs text-red-500 ml-1">Please select a specialization</p>
                    </div>
                
                    <div class="space-y-1">
                        <label class="text-sm font-bold text-gray-700 ml-1">Experience (Years) <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="experience" placeholder="5" 
                            [class.border-red-500]="advisorForm.get('experience')?.invalid && advisorForm.get('experience')?.touched"
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('experience')?.invalid && advisorForm.get('experience')?.touched" class="text-xs text-red-500 ml-1">Enter valid years of experience</p>
                    </div>
                
                    <div class="space-y-1 md:col-span-2">
                        <label class="text-sm font-bold text-gray-700 ml-1">Address Location <span class="text-red-500">*</span></label>
                        <input type="text" formControlName="location" placeholder="Noida Sec 49, UP" 
                            [class.border-red-500]="advisorForm.get('location')?.invalid && advisorForm.get('location')?.touched"
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('location')?.invalid && advisorForm.get('location')?.touched" class="text-xs text-red-500 ml-1">Location is required</p>
                    </div>
                </div>
            </div>

            <hr class="border-gray-100">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div>
                    <h3 class="text-xl font-bold text-gray-900">Contact Information</h3>
                    <p class="text-sm text-gray-500 mt-1">Primary contact to reach the advisor.</p>
                </div>
                <div class="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6">
    
                    <div class="space-y-2 md:col-span-2">
                        <label class="text-sm font-bold text-gray-700 ml-1">Email Address <span class="text-red-500">*</span></label>
                        <input type="email" formControlName="email" 
                            [class.border-red-500]="advisorForm.get('email')?.invalid && advisorForm.get('email')?.touched"
                            placeholder="john.smith@example.com" 
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('email')?.errors?.['required'] && advisorForm.get('email')?.touched" class="text-xs text-red-500 ml-1">Email is required</p>
                        <p *ngIf="advisorForm.get('email')?.errors?.['email'] && advisorForm.get('email')?.touched" class="text-xs text-red-500 ml-1">Please enter a valid email format</p>
                    </div>
                
                    <div class="space-y-2">
                        <label class="text-sm font-bold text-gray-700 ml-1">Phone Number <span class="text-red-500">*</span></label>
                        <input type="tel" formControlName="phone" 
                            [class.border-red-500]="advisorForm.get('phone')?.invalid && advisorForm.get('phone')?.touched"
                            placeholder="9876543210" 
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('phone')?.touched && advisorForm.get('phone')?.invalid" class="text-xs text-red-500 ml-1">Valid phone number required</p>
                    </div>
                
                    <div class="space-y-2">
                        <label class="text-sm font-bold text-gray-700 ml-1">Alternative Phone <span class="text-gray-400 font-normal">(Optional)</span></label>
                        <input type="tel" formControlName="alternativePhone" 
                            [class.border-red-500]="advisorForm.get('alternativePhone')?.invalid && advisorForm.get('alternativePhone')?.dirty"
                            placeholder="9876543211" 
                            class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                        <p *ngIf="advisorForm.get('alternativePhone')?.errors?.['pattern']" class="text-xs text-red-500 ml-1">Invalid phone format</p>
                    </div>
                </div>
            </div>

            <hr class="border-gray-100">

            <div class="max-w-6xl mx-auto">
                <header class="mb-8">
                    <div>
                        <h3 class="text-xl font-bold text-gray-900">Access Control</h3>
                        <p class="text-sm text-gray-500 mt-1">Define what each user role can see and do within the portal.</p>
                    </div>
                    <!-- <h1 class="text-3xl font-black text-gray-900 tracking-tight">Access Control</h1>
      <p class="text-gray-500 font-medium">Define what each user role can see and do within the portal.</p> -->
                </header>

                <div class="flex flex-col lg:flex-row gap-8">

                    <aside class="w-full lg:w-72 space-y-2">
                        <p class="text-[11px] font-bold text-gray-400 uppercase tracking-widest px-4 mb-3">System Roles</p>
                        @for (role of roles; track role.id) {
                        <button (click)="selectRole(role)" type="button" [class]="selectedRole.id === role.id ? 'bg-indigo-600 text-white shadow-indigo-200 shadow-lg' : 'bg-white text-gray-600 hover:bg-indigo-50 border border-gray-200'" class="w-full flex items-center justify-between px-4 py-3.5 rounded-2xl transition-all duration-200 group">
                            <span class="font-bold tracking-tight">{{ role.label }}</span>
                            <svg class="w-5 h-5 opacity-50 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path d="M9 5l7 7-7 7" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                        }
                    </aside>

                    <main class="flex-grow">
                        <div class="bg-white border border-gray-200 rounded-3xl overflow-hidden shadow-sm">
                            <div class="p-6 border-b border-gray-100 flex justify-between items-center bg-white sticky top-0 z-10">
                                <div>
                                    <h2 class="text-xl font-black text-gray-900">{{ selectedRole.label }} Permissions</h2>
                                    <p class="text-sm text-gray-400">Settings applied to all users with this role.</p>
                                </div>
                            </div>
                            <div class="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
    
                                <div class="space-y-2">
                                    <label class="text-sm font-bold text-gray-700 ml-1">Password <span class="text-red-500">*</span></label>
                                    <input type="password" autocomplete="new-password" formControlName="password" placeholder="Minimum 8 characters" 
                                        [class.border-red-500]="advisorForm.get('password')?.invalid && advisorForm.get('password')?.touched"
                                        class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                                    
                                    <div *ngIf="advisorForm.get('password')?.touched && advisorForm.get('password')?.invalid" class="text-xs text-red-500 ml-1">
                                        <span *ngIf="advisorForm.get('password')?.errors?.['required']">Password is required</span>
                                        <span *ngIf="advisorForm.get('password')?.errors?.['minlength']">Must be at least 8 characters</span>
                                    </div>
                                </div>
                            
                                <div class="space-y-2">
                                    <label class="text-sm font-bold text-gray-700 ml-1">Confirm Password <span class="text-red-500">*</span></label>
                                    <input type="password" autocomplete="new-password" formControlName="c_pass" placeholder="Re-enter password" 
                                        [class.border-red-500]="advisorForm.get('c_pass')?.invalid && advisorForm.get('c_pass')?.touched"
                                        class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all">
                                    
                                    <p *ngIf="advisorForm.get('c_pass')?.touched && advisorForm.get('c_pass')?.hasError('isMatching')" class="text-xs text-red-500 ml-1">
                                        Passwords do not match
                                    </p>
                                </div>
                            </div>
                            <hr class="border-gray-100">
                            <div class="p-6 grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="selectedRole.id !='user'">
                                @for (perm of selectedRole.permissions | keyvalue; track perm.key) {
                                <div class="flex items-center justify-between p-4 rounded-2xl border border-gray-50 bg-gray-50/50 hover:bg-white hover:border-indigo-100 hover:shadow-sm transition-all group">
                                    <div class="flex flex-col">
                                        <span class="text-sm font-bold text-gray-700">{{ formatLabel(perm.key) }}</span>
                                        <span class="text-[10px] text-gray-400 uppercase font-medium">Module Access <span class="text-red-500">*</span></span>
                                    </div>

                                    <label class="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" [checked]="perm.value" (change)="togglePermission(perm.key)" class="sr-only peer">
                                        <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                                    </label>
                                </div>
                                }
                            </div>

                            <div class="p-4 bg-amber-50 border-t border-amber-100 flex gap-3">
                                <svg class="w-5 h-5 text-amber-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" stroke-width="2" />
                                </svg>
                                <p class="text-[11px] text-amber-700 leading-relaxed font-medium">
                                    <strong>Security Note:</strong> Changing these permissions will affect all existing users assigned to the <strong>{{ selectedRole.label }}</strong> role immediately upon their next login.
                                </p>
                            </div>
                        </div>
                    </main>

                </div>
            </div>


            <hr class="border-gray-100">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div>
                    <h3 class="text-xl font-bold text-gray-900">Assign Properties</h3>
                    <p class="text-sm text-gray-500 mt-1">Select the properties this advisor will manage.</p>
                </div>
                <div class="lg:col-span-2 space-y-6">
                    <div class="relative">
                        <label class="text-sm font-bold text-gray-700 ml-1 mb-2 block">Search Property</label>
                        <div class="relative">
                            <input type="text" #searchInput (input)="filterResults(searchInput.value)" id="property-search" placeholder="Click to search properties..." class="peer w-full pl-12 pr-10 py-4 rounded-2xl border-2 border-indigo-100 focus:border-indigo-500 outline-none bg-white transition-all shadow-sm">
                            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <div class="absolute z-30 mt-3 w-full bg-white rounded-2xl shadow-2xl border border-gray-100 max-h-72 overflow-y-auto py-2 opacity-0 invisible translate-y-2 peer-focus:opacity-100 peer-focus:visible peer-focus:translate-y-0 transition-all duration-300">
                                <div class="px-4 py-2 text-xs font-bold text-gray-400 uppercase tracking-widest">Available Listings</div>
                                <div *ngFor="let property of properties" (click)="toggleProperty(property)" class="px-4 py-3 hover:bg-indigo-50 cursor-pointer flex items-center gap-4 transition-colors">
                                    <div class="w-12 h-12 rounded-lg bg-indigo-50 flex items-center justify-center overflow-hidden border border-gray-100">
                                        <img #propertyImg [src]="(property?.galleryImage?.length > 0 && property.galleryImage[0]) ? property.galleryImage[0] : 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=100&auto=format&fit=crop'" (error)="propertyImg.src = 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=100&auto=format&fit=crop'" class="w-full h-full object-cover" alt="Property thumbnail" />
                                    </div>

                                    <div class="flex-grow">
                                        <p class="text-sm font-bold text-gray-900 line-clamp-1">{{property.name}}</p>
                                        <p class="text-xs text-gray-500 flex items-center gap-1">
                                            <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            {{property?.location}}
                                        </p>
                                    </div>

                                    <span class="px-2 py-1 bg-green-100 text-green-700 text-[10px] font-black rounded uppercase">Active</span>
                                </div>
                                <div class="px-4 py-3 bg-gray-50 text-center text-xs text-gray-400 italic">Keep typing to narrow down results...</div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-3 mt-4">
                        <div *ngFor="let selected of selectedProperties" class="px-4 py-2 bg-indigo-50 border border-indigo-100 rounded-xl text-indigo-700 flex items-center gap-2">
                            <span class="text-sm font-bold">{{selected.name}}</span>
                            <button type="button" (click)="removeProperty(selected._id)" class="hover:text-red-500 transition-colors">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="border-gray-100">

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div>
                    <h3 class="text-xl font-bold text-gray-900">About Advisor</h3>
                    <p class="text-sm text-gray-500 mt-1">Brief summary.</p>
                </div>
                <div class="lg:col-span-2">
                    <textarea formControlName="aboutAdvisor" rows="4" placeholder="Write a short professional bio..." class="w-full px-4 py-3 rounded-xl border-2 border-gray-100 focus:border-indigo-500 outline-none bg-gray-50/50 transition-all resize-none"></textarea>
                </div>
            </div>

            <div class="flex flex-col sm:flex-row items-center justify-end gap-4 pt-6 border-t border-gray-100">
                <button type="button" (click)="advisorForm.reset(); selectedProperties = []" class="w-full sm:w-auto px-8 py-3 text-gray-500 font-bold hover:text-gray-800 transition-colors">
                    Discard Draft
                </button>
                <button type="submit" [disabled]="advisorForm.invalid" class="w-full sm:w-auto px-12 py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-extrabold rounded-2xl shadow-xl transition-all transform hover:-translate-y-1 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none">
                    Register Advisor Profile
                </button>
            </div>
        </form>
    </div>
</div>


<div *ngIf="isOnboard()" class="fixed inset-0 z-50 flex items-center justify-center p-4 overflow-x-hidden overflow-y-auto bg-gray-900 bg-opacity-60 backdrop-blur-sm transition-opacity">
    <div class="relative w-full max-w-md p-8 bg-white rounded-2xl shadow-2xl transform transition-all scale-100 animate-bounce-in">
        <div class="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
            <svg class="h-12 w-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
            </svg>
        </div>

        <div class="text-center">
            <h3 class="text-2xl font-bold text-gray-900 mb-2">Advisor Onboarded Successfully!</h3>
            <p class="text-gray-600 mb-8">
                Advisor <strong>{{ advisorForm.get('name')?.value }}</strong> has been onboard to Circled+. What would you like to do next?
            </p>
        </div>

        <div class="flex flex-col gap-3">
            <button (click)="navigateToAdvisorList()" class="w-full inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 shadow-md transition-all duration-300 hover:scale-[1.02]">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                </svg>
                Advisors
            </button>

            <button (click)="advisorForm.reset();isOnboard.set(false)" class="w-full inline-flex justify-center items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-xl text-gray-700 bg-white hover:bg-gray-50 transition-all duration-300">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
                </svg>
                Onboard Another Advisor
            </button>
        </div>
    </div>
</div>


<!-- assined proprty -->
<!-- <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 mb-12 animate-fade-in">
    
    <div class="bg-white rounded-3xl border border-gray-100 shadow-2xl overflow-hidden">
        
        <div class="bg-gradient-to-r from-indigo-600 to-purple-600 px-8 py-10 text-white">
            <h2 class="text-3xl font-extrabold tracking-tight">Assign Advisor Properties</h2>
            <p class="text-indigo-100 mt-2 text-lg">Search and link specific properties to this professional profile.</p>
        </div>

        <form class="p-8 lg:p-12 space-y-10">
            
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div>
                    <h3 class="text-xl font-bold text-gray-900">Property Linkage</h3>
                    <p class="text-sm text-gray-500 mt-1">The dropdown below will open automatically when you click the search bar.</p>
                </div>
                
                <div class="lg:col-span-2 space-y-6">
                    <div class="relative">
                        <label class="text-sm font-bold text-gray-700 ml-1 mb-2 block">Search Property</label>
                        
                        <div class="relative">
                            <input type="text" 
                                   id="property-search"
                                   placeholder="Click to search properties..." 
                                   class="peer w-full pl-12 pr-10 py-4 rounded-2xl border-2 border-indigo-100 focus:border-indigo-500 outline-none bg-white transition-all shadow-sm"
                            >
                            <svg class="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-indigo-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>

                            <div class="absolute z-30 mt-3 w-full bg-white rounded-2xl shadow-2xl border border-gray-100 max-h-72 overflow-y-auto py-2 opacity-0 invisible translate-y-2 peer-focus:opacity-100 peer-focus:visible peer-focus:translate-y-0 transition-all duration-300">
                                
                                <div class="px-4 py-2 text-xs font-bold text-gray-400 uppercase tracking-widest">Available Listings</div>

                                <div class="px-4 py-3 hover:bg-indigo-50 cursor-pointer flex items-center gap-4 transition-colors">
                                    <div class="w-12 h-12 rounded-lg bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold">SP</div>
                                    <div class="flex-grow">
                                        <p class="text-sm font-bold text-gray-900">Skyline Penthouse</p>
                                        <p class="text-xs text-gray-500">Bandra West, Mumbai</p>
                                    </div>
                                    <span class="px-2 py-1 bg-green-100 text-green-700 text-[10px] font-black rounded uppercase">Active</span>
                                </div>

                                <div class="px-4 py-3 hover:bg-indigo-50 cursor-pointer flex items-center gap-4 transition-colors border-t border-gray-50">
                                    <div class="w-12 h-12 rounded-lg bg-purple-100 flex items-center justify-center text-purple-600 font-bold">GV</div>
                                    <div class="flex-grow">
                                        <p class="text-sm font-bold text-gray-900">Green Valley Estate</p>
                                        <p class="text-xs text-gray-500">Pune, Maharashtra</p>
                                    </div>
                                    <span class="px-2 py-1 bg-green-100 text-green-700 text-[10px] font-black rounded uppercase">Active</span>
                                </div>

                                <div class="px-4 py-3 hover:bg-indigo-50 cursor-pointer flex items-center gap-4 transition-colors border-t border-gray-50">
                                    <div class="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 font-bold">OR</div>
                                    <div class="flex-grow">
                                        <p class="text-sm font-bold text-gray-900">Oceanic Residency</p>
                                        <p class="text-xs text-gray-500">Goa, Beachfront</p>
                                    </div>
                                    <span class="px-2 py-1 bg-yellow-100 text-yellow-700 text-[10px] font-black rounded uppercase">Pending</span>
                                </div>

                                <div class="px-4 py-3 bg-gray-50 text-center text-xs text-gray-400 italic">
                                    Keep typing to narrow down results...
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-wrap gap-3 mt-4">
                        <div class="px-4 py-2 bg-indigo-50 border border-indigo-100 rounded-xl text-indigo-700 flex items-center gap-2">
                            <span class="text-sm font-bold">Skyline Penthouse</span>
                            <button type="button" class="hover:text-red-500 transition-colors">
                                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" /></svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end pt-8 border-t border-gray-100">
                <button type="submit" class="px-12 py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-extrabold rounded-2xl shadow-xl shadow-indigo-100 transition-all active:scale-95">
                    Save Assignments
                </button>
            </div>
        </form>
    </div>
</div> -->